<div class="toast-wrapper mb-12">
<div class="toast-container flex items-start pt-12 pb-12 pr-16 pl-16 mb-0" [ngClass]="type">
  <div class="icon mr-8 mt-10">
    <mat-icon *ngIf="type === 'success'" svgIcon="check_circle" class="check-icon"></mat-icon>
    <mat-icon *ngIf="type === 'error'" svgIcon="cancel" class="close-icon"></mat-icon>
  </div>

  <div class="toast-content flex-grow">
    <div class="toast-title fs-18 fw-600 mt-10">{{ title }}</div>
    <div class="toast-message fs-14 fw-400">{{ message }}</div>
  </div>

  <div class="toast-actions flex flex-row mt-10">
    <mat-icon [svgIcon]="copied ? 'check' : 'content_copy'" class="copy-icon mb-6" (click)="copyMessage($event)"></mat-icon>
    <mat-icon svgIcon="close" class="close mb-6" (click)="closeToast()"></mat-icon>
  </div>
</div>
<div class="progress-bar-container">
    <div class="toast-progress-bar" [ngStyle]="{ width: progress + '%' }"></div>
</div>
</div>